class CustomFilterDropdown {
  constructor(group) {
    this.group = group;
    this.checkboxes = Array.from(group.querySelectorAll('.custom-filter__checkbox'));
    this.toggle = group.querySelector('[data-custom-toggle]');
    this.dropdown = group.querySelector('.custom-filter__dropdown');
    this.items = Array.from(group.querySelectorAll('.custom-filter__item'));
    this.badge = group.querySelector('[data-filter-count]');
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    this.items.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectItem(item);
      });
    });
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.toggle.classList.toggle('active', this.isOpen);
    this.dropdown.style.height = this.isOpen ? 'auto' : '0';
  }

  close() {
    this.isOpen = false;
    this.toggle.classList.remove('active');
    this.dropdown.style.height = '0';
  }

  selectItem(item) {
    const idx = parseInt(item.getAttribute('data-checkbox-index'), 10);
    const checkbox = this.checkboxes[idx];
    if (!checkbox || checkbox.disabled) return;

    checkbox.checked = !checkbox.checked;
    item.classList.toggle('is-selected', checkbox.checked);
    this.updateBadge();
  }

  updateBadge() {
    if (!this.badge) return;
    const count = this.checkboxes.filter((cb) => cb.checked).length;
    this.badge.textContent = count;
    this.badge.style.display = count > 0 ? '' : 'none';
  }

  reset() {
    this.checkboxes.forEach((cb) => { cb.checked = false; });
    this.items.forEach((item) => item.classList.remove('is-selected'));
    this.updateBadge();
    this.close();
  }
}

class CustomFilterManager {
  constructor(formSelector) {
    this.form = document.querySelector(formSelector);
    if (!this.form) return;

    this.dropdowns = [];
    this.init();
  }

  init() {
    this.form.querySelectorAll('[data-custom-filter-group]').forEach((group) => {
      this.dropdowns.push(new CustomFilterDropdown(group));
    });

    this.bindGlobalEvents();
  }

  bindGlobalEvents() {
    // Close all on outside click
    document.addEventListener('click', () => this.closeAll());

    // Close dropdowns on apply (theme handles filter submission via data-button="apply")
    // Close dropdowns on apply (theme handles filter submission via data-button="apply")
    this.form.querySelectorAll('.custom-filter__apply').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        const hasSelection = !!this.form.querySelector('.custom-filter__checkbox:checked');

        if (hasSelection) {
          this.form.classList.add('filter-apply');
        } else {
          this.form.classList.remove('filter-apply');
        }

        this.closeAll();
      });
    });
    
    // Clear all filters
    const clearBtn = this.form.querySelector('[js-custom-clear-all]');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => this.clearAll());
    }
  }

  closeAll() {
    this.dropdowns.forEach((dd) => dd.close());
  }

  closeAllExcept(activeDropdown) {
    this.dropdowns.forEach((dd) => {
      if (dd !== activeDropdown) dd.close();
    });
  }

  clearAll() {
    this.dropdowns.forEach((dd) => dd.reset());
    // Trigger the theme's filter pipeline via the apply button
    const applyBtn = this.form.querySelector('[data-button="apply"]');
    if (applyBtn) applyBtn.click();
  }
}

// Override toggle to close siblings
const manager = new CustomFilterManager('.custom-filter[data-filter-form]');
if (manager.form) {
  manager.dropdowns.forEach((dropdown) => {
    const originalToggle = dropdown.toggleDropdown.bind(dropdown);
    dropdown.toggleDropdown = function () {
      manager.closeAllExcept(this);
      originalToggle();
    };
  });
}